import React, { Component } from 'react'
import styled from 'styled-components';
import AutoFitText from '../../../commons/components/text/AutoFitText';

class TitleWithCard extends Component {
  render() {
    return (
      <Container>
        <Title>
          <AutoFitText min={12} max={16}>
            {this.props.title}
          </AutoFitText>
        </Title>
        <Card>{this.props.children}</Card>
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  min-width: 0;  
  height: 238px;
`;
const Title = styled.h3`
  font-size: 16px;
  font-weight: 700px;
  line-height: 26px;
  margin-bottom: 12px;
`;
const Card = styled.div`
  width: 100%;
  height: 200px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(213, 216, 222, 1)
`;

export default TitleWithCard;